import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../context/AuthContext';
import { immobilizeVehicle, mobilizeVehicle } from '../../../api/ownerTelematics';

const BADGE = {
  active: 'bg-green-100 text-green-700',
  armed: 'bg-amber-100 text-amber-700',
  immobilized: 'bg-red-100 text-red-700',
};

export default function ImmobilizerControl({ vehicleId, state = 'active', onChanged }) {
  const { t } = useTranslation();
  const { token } = useAuth();
  const [busy, setBusy] = useState(false);
  const [confirming, setConfirming] = useState(false);
  const [error, setError] = useState(null);

  const doImmobilize = async () => {
    setBusy(true); setError(null);
    try { const d = await immobilizeVehicle(vehicleId, token); onChanged && onChanged(d.state); }
    catch (e) { setError(t('ownerTelematics.immobilizer.error')); }
    finally { setBusy(false); setConfirming(false); }
  };
  const doRelease = async () => {
    setBusy(true); setError(null);
    try { const d = await mobilizeVehicle(vehicleId, token); onChanged && onChanged(d.state); }
    catch (e) { setError(t('ownerTelematics.immobilizer.error')); }
    finally { setBusy(false); }
  };

  return (
    <div className="rounded-xl border bg-white p-4">
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-gray-800">{t('ownerTelematics.immobilizer.title')}</span>
        <span className={`rounded-full px-2 py-0.5 text-xs ${BADGE[state] || BADGE.active}`}>
          {t(`ownerTelematics.immobilizer.state.${state}`)}
        </span>
      </div>

      <div className="mt-3">
        {state === 'active' ? (
          confirming ? (
            <div className="space-y-2">
              <p className="text-xs text-gray-600">{t('ownerTelematics.immobilizer.confirm')}</p>
              <div className="flex gap-2">
                <button onClick={doImmobilize} disabled={busy} className="rounded bg-red-600 px-3 py-1.5 text-sm text-white disabled:opacity-50">
                  {busy ? t('common.loading') : t('ownerTelematics.immobilizer.confirmYes')}
                </button>
                <button onClick={() => setConfirming(false)} className="rounded px-3 py-1.5 text-sm">{t('common.cancel')}</button>
              </div>
            </div>
          ) : (
            <button onClick={() => setConfirming(true)} className="rounded-lg bg-red-600 px-4 py-2 text-sm text-white">
              {t('ownerTelematics.immobilizer.immobilize')}
            </button>
          )
        ) : (
          <button onClick={doRelease} disabled={busy} className="rounded-lg bg-green-600 px-4 py-2 text-sm text-white disabled:opacity-50">
            {busy ? t('common.loading') : t('ownerTelematics.immobilizer.release')}
          </button>
        )}
        {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
      </div>
    </div>
  );
}
